import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ChangeSemesterOrderUseCaseInterface } from 'domain/usecases';

export class RemoteChangeSemesterOrder
  implements ChangeSemesterOrderUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: ChangeSemesterOrderUseCaseInterface.Params,
  ): Promise<ChangeSemesterOrderUseCaseInterface.Result> {
    const { id, ...restParams } = params;

    const requestUrl = `${this.url}/reorder/${id}`;

    const httpResponse = await this.httpClient.request({
      url: requestUrl,
      body: restParams,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
